import {Routes, Route, Link} from 'react-router-dom';
import Card from "./components/Card";
import WorksHeader from './components/WorksHeader';

export default function Repertoire (props){

    const workList = props.works.map(work=>{
        return <Card work={work} key={work.title}/>
    })

    return (
        <>
            {/* <div className="row" id="headerBar">
                <Link to={"/"}><span>JAY "KURZWIEL" OYEBADEJO</span></Link>
                <div className="row">
                    <div className="col-4">
                        <span>WORKS</span>
                    </div>
                    <div className="col-4">
                        <Link to={"socials"}><span>SOCIALS</span></Link>
                    </div>
                    <div className="col-4">
                        <a href="mailto:jay@krzwlmusic.com">CONTACT</a>
                    </div>
                </div>
            </div> */}
            <WorksHeader />
            <div className="credits">{workList}</div>
        </>
    )
    
}